// Language-specific stories (TransformedReport.storiesByLanguage) carry ids of
// the form "<crassId>-<locale>", e.g. "11446-de". This returns the bare CRASS id;
// ids without a locale suffix are returned unchanged.
export const stripLanguageSuffix = (id: string | number): string =>
  String(id).replace(/-[a-z]{2}$/i, "");
